import i18n from '@/i18n'
import jobList from './companyJobList'
import Layout from './pc/layout.vue'
// import PCCompanyBranding from './pc/companyBranding.vue'
// import MobileCompanyBranding from './mobile/companyBranding.vue'
import CompanyInfoRoute from './mobile/companyInfo/route'
// import { deviceType } from '@/utils/common'
import CompanyPageRoute from './pc/route'
import MSDCustomRoute from './msdCustomUrl/route'
import MSDSurvey from '@/views/survey/msdCustomUrl/index.vue'
import MSDPreference from '@/views/survey/msdCustomUrl/preference.vue'
import { ROOT_COMPANY_ID } from '@/constant/company'
import QuestionIndex from '@/views/survey/msdCustomUrl/questionIndex.vue'
import Question from '@/views/survey/msdCustomUrl/question.vue'
import Register from './register.vue'
import SurveyJobListRedirect from './surveyJobListRedirect.vue'

export default [
  {
    name: 'job-list',
    path: '/mobile-web-more-jobs/:companyId',
    component: jobList,
    meta: {
      noAuth: true,
      title: i18n.t('companyJobList.title')
    }
  },
  {
    name: 'msdCustomSurvey',
    path: '/msdchina/join-talent-community',
    component: MSDSurvey,
    redirect: '/msdchina/join-talent-community/preference',
    meta: {
      noAuth: true,
      title: '加入默沙东人才社区',
      customCompanyId: ROOT_COMPANY_ID.MSD
    },
    children: [
      {
        name: 'msdCustomPreference',
        path: '/msdchina/join-talent-community/preference',
        component: MSDPreference,
        meta: {
          title: '加入默沙东人才社区',
          customCompanyId: ROOT_COMPANY_ID.MSD
        }
      },
      {
        name: 'msdSurveyQuestionIndex',
        path: '/msdchina/join-talent-community/question',
        component: QuestionIndex,
        redirect: '/msdchina/join-talent-community/question/1',
        meta: {
          customCompanyId: ROOT_COMPANY_ID.MSD,
          get title () {
            return i18n.t('survey.title.surveyQuestion')
          }
        },
        children: [
          {
            name: 'msdSurveyQuestionStep',
            path: '/msdchina/join-talent-community/question/:step',
            component: Question,
            meta: {
              customCompanyId: ROOT_COMPANY_ID.MSD,
              get title () {
                return i18n.t('survey.title.surveyQuestion')
              }
            }
          }
        ]
      }
    ]
  },
  {
    path: '/recruiting/company/:companyId/survey/job-list-redirect',
    component: SurveyJobListRedirect,
    meta: {
      noAuth: true
    }
  },
  // {
  //   name: 'company-detail',
  //   path: `${basePath}/company-detail/:companyId`,
  //   component: deviceType.isPc ? PCCompanyBranding : MobileCompanyBranding,
  //   meta: {
  //     noAuth: true,
  //     title: i18n.t('companyJobList.title')
  //   }
  // },
  CompanyInfoRoute,
  {
    path: '/recruiting/company/:companyId',
    component: Layout,
    meta: {
      noAuth: true
    },
    children: CompanyPageRoute
  },
  MSDCustomRoute,
  {
    name: 'company-register',
    path: '/passport/company/register',
    component: Register,
    meta: {
      permission: 'PERM_COMPANY_APPROVAL',
      get title () {
        return i18n.t('login.common.title.companyRegister')
      }
    }
  }
]
